import { Component, Mixins, Prop } from 'vue-property-decorator';
import { EdSectionOptions } from '@/content/models/ed-section-options.model';
import { COURSE_STORAGE_KEYS } from '@/courses/values/courses.values';
import { LocalStorageService } from '@/services/local-storage.service';
import Course from '@/content/models/course.model'
import { CourseToolsMixin } from './course-tools.mixin';
import EdConfirmMessage from '@/courses/components/ed-confirm-message/ed-confirm-message.component.vue';

@Component({
  components: {
    EdConfirmMessage
}})
export class MaterialMixin extends Mixins(CourseToolsMixin) {

  /* Props */
  @Prop({default: null}) readonly options: EdSectionOptions;
  @Prop({default: null}) readonly courseId: number;
  @Prop({default: null}) readonly classId: number;
  @Prop({default: null}) readonly section: any;
  @Prop({default: null}) readonly material: any;
  @Prop({default: null}) readonly contentType: string;

  /* Data */
  public parentWillUpdate: boolean  = false;
  public editingObject: boolean = false
  public showTeacherOnlyMessage: boolean = false;
  public dontAskAgaingTeaherOnly: boolean = false;

  /* Computed */
  get courseID(): number {
    if(this.courseId) return this.courseId;
    else if(this.section) return this.section.courseId;
    else return this.material?.courseId;
  }

  get classID(): number {
    if(this.classId) return this.classId;
    else if(this.section) return this.section.classId;
    else return this.material ? this.material.classId : null;
  }

  get course(): Course {
    return this.getCourseFromStore({courseId: this.courseID , classId: this.classID});
  }

  setFolderInStorage(folderId: number, parentId?: number) {
    let state = LocalStorageService.getItem(COURSE_STORAGE_KEYS.ED_COURSE_VIEWER_FOLDERS_STATE) || {};
    if(state instanceof Array){      
      state = {};
    }
    let folders: number[] = state[this.courseID] ? state[this.courseID] : [];
    if(folders.includes(folderId)) {
      let i = folders.findIndex(f => f == folderId);
      folders.splice(i, folders.length - i);
      this.setSectionInStorage(null);
    } else if(parentId) {
      folders.push(folderId);
    } else {
      folders = [folderId];
      this.setSectionInStorage(null);
    }
    state[this.courseID] = folders;
    LocalStorageService.setItem(
      COURSE_STORAGE_KEYS.ED_COURSE_VIEWER_FOLDERS_STATE,
      state
    );
  }

  setSectionInStorage(sectionId: number) {
    let currentSectionState = LocalStorageService.getItem(COURSE_STORAGE_KEYS.ED_COURSE_VIEWER_SECTION_STATE) || {};
    let currentMaterialState = LocalStorageService.getItem(COURSE_STORAGE_KEYS.ED_COURSE_VIEWER_MATERIAL_STATE) || {};
    let currentProjectState = LocalStorageService.getItem(COURSE_STORAGE_KEYS.ED_COURSE_VIEWER_PROJECT_STATE) || {};

    if(typeof currentSectionState === 'number'){
      currentSectionState = {};
    }

    if(sectionId) {
      currentMaterialState = {...currentMaterialState, [this.courseID] : sectionId};
      delete currentSectionState[this.courseID];
      delete currentProjectState[this.courseID];
    } else {
      delete currentMaterialState[this.courseID];
    }
    LocalStorageService.setItem(
      COURSE_STORAGE_KEYS.ED_COURSE_VIEWER_MATERIAL_STATE, currentMaterialState
    );
    LocalStorageService.setItem(
      COURSE_STORAGE_KEYS.ED_COURSE_VIEWER_SECTION_STATE, currentSectionState
    );
    LocalStorageService.setItem(
      COURSE_STORAGE_KEYS.ED_COURSE_VIEWER_PROJECT_STATE, currentProjectState
    );
  }

  async setTeacherOnlyMaterial(object) {
    this.editingObject = true;
    if(Object.prototype.hasOwnProperty.call(object,'sectionName')) {
      this.parentWillUpdate = true;
      let payload = {
        sectionId: object.sectionId,
        teacherOnly: object.teacherOnly,
        section: object,
        courseId: this.courseID,
        saveMessageTeacherOnly: object.data?.saveMessageTeacherOnly ?? object.saveMessageTeacherOnly
      }
      await this.$Courses.Store.updateSectionMaterialVisibilityA(payload);
      await this.getContentForCourse({courseId: this.courseID , classId: this.classID});
      this.editingObject = false;
    }
    else { 
      let payload = {
        materialId: object.relatedContentId,
        teacherOnly: object.data.teacherOnly,
        name: object.data.title,
        offset: object.data.offset,
        parentId: object.sectionParentId,
        saveMessageTeacherOnly: object.data?.saveMessageTeacherOnly ?? object.saveMessageTeacherOnly
      }
      let data = {data: payload, courseId: this.courseID};
      await this.$Courses.Store.updateCourseMaterialA(data);
      if(!this.parentWillUpdate) {
        await this.getContentForCourse({courseId: this.courseID , classId: this.classID});
        this.editingObject = false;
      }
    }
  }

  setParentWillUpdate(value: boolean) {
    this.parentWillUpdate = value
  }

}